function init() {

  window.addEventListener('cfReady', function(event) {

    const firstTouchPoint = getCookie('first_touchpoint');
    const mostRecentTouchPoint = getCookie('most_recent_touchpoint');
    const firstTouchPointInput = document.getElementById('contact_extra_first_session_source');
    const mostRecentTouchPointInput = document.getElementById('contact_extra_conversion_session_source');

    firstTouchPointInput.value = firstTouchPoint
    mostRecentTouchPointInput.value = mostRecentTouchPoint

  });


  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
	
}

module.exports = {
  init,
}
